import { createSlice } from "@reduxjs/toolkit";
import { revertAll } from "../revertAll/RevertStateReducer";

const initialState = {
  // ---- session ----
  user: null,
  permissions: [],
  isAuthenticated: false,
  isLoading: false,
  error: null,

  // ---- forgot password ----
  forgotPasswordLoading: false,
  forgotPasswordSuccess: false,
  forgotPasswordError: null,

  // ---- organization registration ----
  registerOrgLoading: false,
  registerOrgSuccess: false,
  registerOrgError: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => builder.addCase(revertAll, () => initialState),
  reducers: {
    // ........... login state ...............
    fetchLoginUserStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchLoginUserSuccess(state, action) {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.user = action.payload.user || null;
      state.permissions = action.payload.permissions || [];
      state.error = null;
    },
    fetchLoginUserFailure(state, action) {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.error = action.payload;
    },

    checkSessionInconclusive(state) {
  state.isLoading = false;
},

       // ........... logout state ...............
    logoutUserStart(state) {
      state.isLoading = true;
    },
    logoutUser(state) {
      state.user = null;
      state.permissions = [];
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = null;
    },

    // ........... forgot password state ...............
    forgotPasswordStart(state) {
      state.forgotPasswordLoading = true;
      state.forgotPasswordSuccess = false;
      state.forgotPasswordError = null;
    },
    forgotPasswordSuccessAction(state) {
      state.forgotPasswordLoading = false;
      state.forgotPasswordSuccess = true;
      state.forgotPasswordError = null;
    },
    forgotPasswordFailure(state, action) {
      state.forgotPasswordLoading = false;
      state.forgotPasswordSuccess = false;
      state.forgotPasswordError = action.payload;
    },
    resetForgotPasswordState(state) {
      state.forgotPasswordLoading = false;
      state.forgotPasswordSuccess = false;
      state.forgotPasswordError = null;
    },

    // ........... register organization state ...............
    registerOrgStart(state) {
      state.registerOrgLoading = true;
      state.registerOrgSuccess = false;
      state.registerOrgError = null;
    },
    registerOrgSuccessAction(state) {
      state.registerOrgLoading = false;
      state.registerOrgSuccess = true;
      state.registerOrgError = null;
    },
    registerOrgFailure(state, action) {
      state.registerOrgLoading = false;
      state.registerOrgSuccess = false;
      state.registerOrgError = action.payload;
    },
    resetRegisterOrgState(state) {
      state.registerOrgLoading = false;
      state.registerOrgSuccess = false;
      state.registerOrgError = null;
    },

    clearAuthError(state) {
      state.error = null;
    },
  },
});

export const {
  fetchLoginUserStart,
  fetchLoginUserSuccess,
  fetchLoginUserFailure,
  logoutUserStart,
  logoutUser,
    checkSessionInconclusive,
  forgotPasswordStart,
  forgotPasswordSuccessAction,
  forgotPasswordFailure,
  resetForgotPasswordState,
  registerOrgStart,
  registerOrgSuccessAction,
  registerOrgFailure,
  resetRegisterOrgState,
  clearAuthError,
} = authSlice.actions;

export default authSlice.reducer;
